import React, { useEffect, useState } from "react";
import { useSortableData } from "src/components/sortTable";
import { useSelector } from "react-redux";
import { Loader } from "src/components/loader";
import _ from "lodash";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { getFloatValue, tConvert } from "src/constant";
import { Tooltip } from "@mui/material";



export const ProjectManagerGoodsInTable = ({ allGoodsInTableData }) => {

  /** redux store useDispatch & useSelector ------------------------------ **/
  const navigate = useNavigate();
  const { goodsinLoadingState } = useSelector((state) => state.goodsin);
  const lookupValues = useSelector((state) => state.lookup.data);

  /** hooks useState ----------------------------------------------------- **/
  const [show, setShow] = useState(false);
  const [selected, setSelected] = useState("");
  const [goodsInShowData, setGoodsInShowData] = useState([]);

  /** hooks useState ----------------------------------------------------- **/
  const PhotoType = lookupValues?.find((v) => v.name === "Pictures")?.id || 0;
  const DocumentType = lookupValues?.find((v) => v.name === "Documents")?.id || 0;
  const depotCount = _.unionBy(_.map(goodsInShowData || [], (d) => d?.depotCode), (d) => d).length;
  const projectCount = _.unionBy(_.map(goodsInShowData || [], (d) => d?.projectName), (d) => d).length;
  const { items, requestSort, sortConfig } = useSortableData(goodsInShowData);

  /** hooks useEffect----------------------------------------------------- **/


  useEffect(() => {
    let setGoodsinData = dataManipulationPipe(allGoodsInTableData);
    let filteredArray = _.filter(setGoodsinData || [], (d) => d.statusValue !== "Review")
    setGoodsInShowData([...filteredArray])
  }, [allGoodsInTableData])

  /** handler functions--------------------------------------------------- **/
  const dataManipulationPipe = (data) => {
    let result = data && data[0] && data.map((o, i) => {
      let temp = { ...o }
      return {
        ...o,
        date: moment(temp.inTime).format("DD-MMM-YYYY HH:mm"),
        referenceNumber: temp.referenceNumber,
        depotCode: temp?.depotCode,
        projectManager: temp?.projectManager,
        clientName: temp?.clientName,
        projectName: temp?.projectName,
        itemsCount: temp?.itemCount || 0,
        damagedCount: temp?.damagedCount || 0,
        interiorSpaceCount: temp?.interiorSpace || 0,
        exteriorSpaceCount: temp?.exteriorSpace || 0,
        status: temp?.statusValue,
        docs: temp?.documents || 0,
        photos: temp?.pictures || 0,
        remarks: temp?.shipmentRemarksCount || 0
      }
    })
    return result || [];
  }

  const getClassNamesFor = (name) => {
    if (!sortConfig) {
      return;
    }
    return sortConfig.key === name ? sortConfig.direction : undefined;
  };

  const handleRowClick = (index) => {
    setSelected(index);
    setShow(!show);
  };

  const calulateItemSpace = (data, type) => {
    let totalSpace = 0;
    data.items &&
      data.items[0] &&
      data.items.map((d) => {
        if (d.storageValue == type) {
          totalSpace = totalSpace + d.spaceOccupied;
        }
      });

    return totalSpace || 0;
  };

  const handleViewRecordClick = (id, event) => {
    if (event.ctrlKey || event.metaKey) {
      window.open(`#/app/goodsin/detail/${id}`, '_blank');
    } else {
      navigate(`/app/goodsin/detail/${id}`)
    }
  }

  if (goodsinLoadingState) {
    return <Loader />;
  }

  return (
    <>
      <div>
        <div
          className={`table-responsive d-flex mt-2 ${items.length < 10 ? "" : "dispatchorder-table-main-div-when-items-more-pm-goodsin"}`}
          id="printablediv"
        >
          <table
            className="table goodsin-table table-borderless"
            style={{ width: "100%" }}
          >
            <thead className="goodsin-table-header">
              <tr>
                <th
                  scope="col"
                  style={{ minWidth: 150 }}
                  className={`${getClassNamesFor("date")}
                 text-uppercase text-primary`}
                  onClick={() => requestSort("date")}
                >
                  In-Time
                </th>
                <th
                  scope="col"
                  className={`${getClassNamesFor(
                    "referenceNumber"
                  )} text-uppercase text-primary set-header-width-for-long-text`}
                  onClick={() => requestSort("referenceNumber")}
                >
                  ref number
                </th>
                <th
                  scope="col"
                  className={`${getClassNamesFor(
                    "projectName"
                  )} text-uppercase text-primary set-header-width-for-long-text`}
                  onClick={() => requestSort("projectName")}
                >
                  project
                </th>
                <th
                  scope="col"
                  className={`${getClassNamesFor(
                    "depotCode"
                  )} text-uppercase text-primary set-header-width-for-medium-text`}
                  onClick={() => requestSort("depotCode")}
                >
                  depot
                </th>
                <th
                  scope="col"
                  className={`${getClassNamesFor("itemsCount")}
                  text-uppercase text-primary set-header-width-for-medium-text`}
                  onClick={() => requestSort("itemsCount")}
                >
                  items
                </th>
                <th
                  scope="col"
                  className={`${getClassNamesFor(
                    "damagedCount"
                  )} text-uppercase text-primary set-header-width-for-medium-text`}
                  onClick={() => requestSort("damagedCount")}
                >
                  dmg
                </th>
                <th
                  scope="col"
                  className={`${getClassNamesFor(
                    "interiorSpaceCount"
                  )} text-primary set-header-width-for-m-text`}
                  onClick={() => requestSort("interiorSpaceCount")}
                >
                  INT.m<sup>2</sup>
                </th>
                <th
                  scope="col"
                  className={`${getClassNamesFor(
                    "exteriorSpaceCount"
                  )} text-primary set-header-width-for-m-text`}
                  onClick={() => requestSort("exteriorSpaceCount")}
                >
                  EXT.m<sup>2</sup>
                </th>
                <th
                  scope="col"
                  className={` text-uppercase text-primary set-header-width-for-small-text`}
                >
                  docs
                </th>
                <th
                  scope="col"
                  className={` text-uppercase text-primary set-header-width-for-small-text`}
                >
                  photos
                </th>
                <th scope="col" className={` text-uppercase text-primary set-header-width-for-small-text`}>
                  Remarks
                </th>
              </tr>
            </thead>
            <tbody className="goods-table-body">
              {items.length > 0 ? (
                items.map((item, index) => {
                  return (
                    <React.Fragment key={index}>
                      <tr
                        onClick={() => handleRowClick(index)}
                        className={`goodsin-tr ${item.status == "pending" ? "red-border-class" : ""
                          } ${selected == index ? "row-border" : ""}`}
                      >
                        <td>{item?.date}</td>
                        <td>{item?.referenceNumber || ""}</td>
                        <td>
                          <Tooltip title={<span className="project-dropdown-tooltip-style2 project-dropdown-tooltip-style">{`${item?.projectName}`}</span>} arrow>
                            <div className="text-truncate-goodsin" >
                              {item?.projectName || ""}
                            </div>
                          </Tooltip>
                        </td>
                        <td>{item?.depotCode || ""}</td>
                        <td>{item?.itemsCount}</td>
                        <td>{item.damagedCount}</td>
                        <td>{getFloatValue(item?.interiorSpaceCount)}</td>
                        <td>{getFloatValue(item?.exteriorSpaceCount)}</td>
                        <td>
                          {item?.docs}
                        </td>
                        <td>
                          {item?.photos}
                        </td>
                        <td>
                          {item?.remarks}
                        </td>


                      </tr>
                      {show && selected == index && (
                        <tr className={`view-record-button`}>
                          <td>
                            <button onClick={(e) => handleViewRecordClick(item.id, e)}
                              type="button"
                              className="text-uppercase view-button"
                            >
                              <i className="bi bi-eye-fill view-record-icon"></i>{" "}
                              View Record
                            </button>
                          </td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })
              ) : (
                <tr>
                  <td
                    className="not-found-txt"
                    colSpan="8"
                    style={{ textAlign: "center" }}
                  >
                    No Records Found
                  </td>
                </tr>
              )}
            </tbody>
            <tfoot className="goodsin-table-footer-style">
              <tr>
                <td></td>

                <td>
                  <span className="footer-count-color">
                    {goodsInShowData.length}{" "}
                  </span>
                  <span className="footer-label-color">Records</span>
                </td>

                <td>
                  <span className="footer-count-color">{projectCount} </span>
                  <span className="footer-label-color">Projects</span>
                </td>

                <td>
                  <span className="footer-count-color">{depotCount} </span>
                  <span className="footer-label-color">Depots</span>
                </td>

                <td>
                  <span className="footer-count-color"> {_.sumBy(goodsInShowData || [], (d) => d.itemsCount)} </span>
                  <span className="footer-label-color">Units</span>
                </td>

                <td>
                  <span className="footer-count-color">
                    {_.sumBy(goodsInShowData || [], (d) => d.damagedCount)}
                  </span>
                  <span className="footer-label-color"> Dmg</span>
                </td>

                <td>
                  <span className="footer-count-color">
                    {getFloatValue(_.sumBy(goodsInShowData || [], (d) => d.interiorSpaceCount))}{" "}
                  </span>
                  <span className="footer-label-color">
                    Int. (m<sup>2</sup>)
                  </span>
                </td>

                <td>
                  <span className="footer-count-color">
                    {getFloatValue(_.sumBy(goodsInShowData || [], (d) => d.exteriorSpaceCount))}{" "}
                  </span>
                  <span className="footer-label-color">
                    Ext. (m<sup>2</sup>)
                  </span>
                </td>

                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </>
  );
};
